import { render, staticRenderFns } from "./Chapter1_3.vue?vue&type=template&id=7d98e4f1&scoped=true&"
import script from "./Chapter1_3.vue?vue&type=script&lang=js&"
export * from "./Chapter1_3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d98e4f1",
  null
  
)

export default component.exports